import { officeLocations } from "@/data";
import { FormData } from "@/types";
import React, { useState } from "react";
import { ContactForm } from "../ContactForm";
import { OfficeLocation } from "../OfficeLocation";
import { SparklesCore } from "../ui/sparkles";
import { trackEvent } from "@/lib/meta-pixel";

export const ContactsPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const handleSubmit = async (data: FormData) => {
    setError(null);
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch('https://liveapi-main-in.nuqiwealth.com:9000/mail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log("Form submitted successfully:", result);
      trackEvent("Lead", { content_name: "Contact Form" });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      console.error("Error submitting form:", err);
    } finally {

      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col bg-black min-h-screen pb-20">
      <div className="h-[10rem] w-full flex -mt-8 flex-col items-center justify-center overflow-hidden rounded-md">
        <h2 className="text-3xl pb-5 font-poppins font-medium leading-6 tracking-wide text-[#57c0af] hover:text-[#57c0af] sm:text-4xl lg:text-4xl">
          Contact Us
        </h2>
        <div className="w-[40rem] h-10 relative">
          {/* Gradients */}
          <div className="absolute inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-[2px] w-3/4 blur-sm" />
          <div className="absolute inset-x-20 top-0 bg-gradient-to-r from-transparent via-indigo-500 to-transparent h-px w-3/4" />
          <div className="absolute inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-[5px] w-1/4 blur-sm" />
          <div className="absolute inset-x-60 top-0 bg-gradient-to-r from-transparent via-sky-500 to-transparent h-px w-1/4" />

          {/* Core component */}
          <SparklesCore
            background="transparent"
            minSize={0.4}
            maxSize={1}
            particleDensity={1200}
            className="w-full h-full"
            particleColor="#030F26"
          />
          {/* Radial Gradient to prevent sharp edges */}
          <div className="absolute inset-0 w-full h-full  [mask-image:radial-gradient(350px_200px_at_top,transparent_20%,white)]"></div>
        </div>
      </div>

      {/* Header */}
      <h1 className="text-center -mt-10 text-3xl font-poppins tracking-wide leading-loose text-white max-md:text-2xl">
        Your questions, Our expertise - Let's talk
      </h1>

      {/* Main Content */}
      <div className="mt-16 w-full px-5 max-w-[1732px] mx-auto max-md:mt-10">
        <div className="grid gap-16 xl:grid-cols-2 grid-cols-1 ">
          {/* Left: Global Offices */}
          <div className="flex flex-col items-center xl:items-start justify-center">
            <div className="text-3xl font-poppins tracking-wide mb-8 lg:pl-6 max-md:text-2xl">
              <span className="text-white">Global</span>
              <span className="text-[#57c0af]"> Offices</span>
            </div>

            {/* Updated Grid for Offices */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 lg:gap-20 max-sm:gap-8">
              {officeLocations.map((office, index) => (
                <OfficeLocation key={index} {...office} />
              ))}
            </div>
          </div>

          {/* Right: Contact Form */}
          <div className="flex justify-center w-full">
            <div className="px-8 pt-10 pb-12 w-[100%] max-w-[600px] md:max-w-[450px] lg:max-w-[500px] bg-black border border-[#57c0af] rounded-[30px] shadow-md max-md:px-6 max-md:pt-8 max-md:pb-10">
              <ContactForm onSubmit={handleSubmit} isLoading={isLoading} error={error} setError={setError} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
